__turbopack_context__.v({
  "footerShadow": "ColumnarLayout-module__Rgr_eq__footerShadow",
  "gridInner": "ColumnarLayout-module__Rgr_eq__gridInner",
  "scrollAreaActualRoot": "ColumnarLayout-module__Rgr_eq__scrollAreaActualRoot",
  "scrollAreaDefault": "ColumnarLayout-module__Rgr_eq__scrollAreaDefault",
});
